export default "__VITE_PUBLIC_ASSET__283dc5e5__"